import { GetSecretValueCommand, SecretsManagerClient } from '@aws-sdk/client-secrets-manager'
import { CLIENT_FACTORY } from '../factories/ClientFactory'

export class SecretsService {
  private static instance: SecretsService
  private client: SecretsManagerClient | undefined

  public constructor() {
    this.client = CLIENT_FACTORY.getSecretsManagerClient()
    console.log('SecretsService client initialized.')
  }

  async getSecretValue(secretName: string): Promise<string> {
    const response = await this.client?.send(
      new GetSecretValueCommand({
        SecretId: secretName
      })
    )

    return response?.SecretString!
  }
}

export default SecretsService
